import SmoothScroll from 'smooth-scroll';
import Gumshoe from 'gumshoejs';
const IS_ACTIVE_CLASS = 'is-active';
const FIXED_POSIOTION = 'fixed-position';

export default function () {
  /* eslint-disable-next-line */
  document.scroll = new SmoothScroll('.navigation__anchor a', {
    speed: 500,
    speedAsDuration: true,
    updateURL: true,
    emitEvents: true,
  });

  function closeHamburger () {
    document.querySelector('.hamburger').classList.remove(IS_ACTIVE_CLASS);
    document.querySelector('.header__navigation').classList.remove(IS_ACTIVE_CLASS);
    document.querySelector('body').classList.remove(FIXED_POSIOTION);
  }
  document.addEventListener('scrollStart', closeHamburger, false);

  const isHomePage = document.querySelector('.home-page');
  if (isHomePage) {
    /* eslint-disable-next-line */
    new Gumshoe('.navigation__anchor a', {
      navClass: 'active',
      contentClass: 'active',
      nested: false,
    });
  }
}
